var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 40,
    viewBox: "0 0 210 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49609 24.8794C1.49609 24.8794 12.7759 25.3677 23.935 28.4073C38.0516 32.2525 44.0041 26.496 53.4905 19.831C60.6409 14.8072 67.0221 17.243 72.0666 24.8794C75.7871 30.5116 81.2094 39.9657 86.8246 38.4437C91.9576 37.0525 95.5965 25.964 102.711 23.144C108.35 20.909 112.933 27.0492 119.426 24.8794C128.235 21.9359 129.547 10.6606 135.843 10.6606C143.613 10.6606 148.479 30.7804 155.548 30.7804C162.575 30.7804 166.19 10.8907 173.876 16.9286C179.753 21.5447 183.66 8.71366 189.218 4.32366C194.775 -0.066334 208.123 1.43912 208.123 1.43912",
    stroke: "#2D2F31",
    strokeWidth: 2.26391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath2);
export default __webpack_public_path__ + "static/media/Path 2.61306a1404a39d89df7154037b01e281.svg";
export { ForwardRef as ReactComponent };